import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 666,
    },
    description: {
      color: COLORS.gray.black,
      marginBottom: theme.spacing(2),
    },
    buttonsWrapper: {
      display: 'flex',
      flexFlow: 'column',
      justifyContent: 'center',
      alignItems: 'stretch',
      borderRadius: theme.shape.borderRadius,
      border: theme.shape.borderGray60,
    },
    channelButton: {
      '& + &': {
        borderTop: theme.shape.borderGray60,
      },
    },
    csvTemplateHint: {
      marginTop: theme.spacing(1),
    },
  }),
  { name: 'ConnectToChannelPopup' }
);
